/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Api_PricesInputs */

const en_nav_api_prices = /** @type {(inputs: Nav_Api_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Prices`)
};

const zh_hans1_nav_api_prices = /** @type {(inputs: Nav_Api_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 价格`)
};

const pt_br2_nav_api_prices = /** @type {(inputs: Nav_Api_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços das APIs`)
};

const es_nav_api_prices = /** @type {(inputs: Nav_Api_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios de APIs`)
};

const fr_nav_api_prices = /** @type {(inputs: Nav_Api_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix des API`)
};

const de_nav_api_prices = /** @type {(inputs: Nav_Api_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Preise`)
};

const ru_nav_api_prices = /** @type {(inputs: Nav_Api_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены на API`)
};

const it_nav_api_prices = /** @type {(inputs: Nav_Api_PricesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi API`)
};

/**
* | output |
* | --- |
* | "API Prices" |
*
* @param {Nav_Api_PricesInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_api_prices = /** @type {((inputs?: Nav_Api_PricesInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Api_PricesInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_nav_api_prices(inputs)
	if (locale === "pt-BR") return pt_br2_nav_api_prices(inputs)
	if (locale === "es") return es_nav_api_prices(inputs)
	if (locale === "fr") return fr_nav_api_prices(inputs)
	if (locale === "de") return de_nav_api_prices(inputs)
	if (locale === "ru") return ru_nav_api_prices(inputs)
	if (locale === "it") return it_nav_api_prices(inputs)
	return en_nav_api_prices(inputs)
});